import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import Text from '../../../common/text';
import { CrossIcon, TickIcon } from '../../../common/icons';
import { PALETTE } from '../../../../constants';
import styles from '../validation.styles';

const errorIconColor = PALETTE.errorColor;
const successIconColor = PALETTE.successColor;

function ValidationLabel({ error, title }) {
  if (error === true) {
    return (
      <View style={styles.root}>
        <CrossIcon color={errorIconColor} />
        <Text
          size="xsmall"
          type="secondary"
          style={styles.validationLabelError}
        >
          {title}
        </Text>
      </View>
    );
  }

  if (error === false) {
    return (
      <View style={styles.root}>
        <TickIcon color={successIconColor} />
        <Text
          size="xsmall"
          type="secondary"
          style={styles.validationLabelSuccess}
        >
          {title}
        </Text>
      </View>
    );
  }

  return (
    <View style={styles.root}>
      <Text size="small" type="secondary">{title}</Text>
    </View>
  );
}

ValidationLabel.propTypes = {
  error: PropTypes.bool,
  title: PropTypes.string,
};

export default ValidationLabel;
